import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useConstantStore } from '@/stores/pinia/useConstantStore';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useExperiment } from '@/libraries/experiment';
import type Provider from '@/interfaces/provider';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyServicesChip',
  props: {
    buyboxType: null,
    showProviderIcons: { type: Boolean, default: true },
    maxProviderIcons: { default: 3 }
  },
  setup(__props: any) {

const props = __props as { buyboxType: 'grid' | 'list', showProviderIcons: boolean, maxProviderIcons: number };

const DEFAULT_PROVIDER_SHORT_NAMES = ['nfx', 'amp', 'prv'];

const filterStore = useFilterStore();
const constantStore = useConstantStore();
const userStore = useUserStore();

const { trackEvent } = useExperiment('EXP_PROVIDER_BUYBOX_V2');



// EXP_PROVIDER_BUYBOX_V2
const providersToDisplay = computed(() => {
	// allProviders falls back to ALL providers when settingsProvider is empty — guard explicitly
	if (!userStore.settingsProvider?.length) {
		const providersByShortName = constantStore.allProvidersByShortName as Record<Provider['shortName'], Provider>;
		return DEFAULT_PROVIDER_SHORT_NAMES.map(shortName => providersByShortName[shortName])
			.filter(Boolean)
			.slice(0, props.maxProviderIcons);
	}
	return filterStore.selectedProvidersByType('my_services').slice(0, props.maxProviderIcons);
});
// EXP_PROVIDER_BUYBOX_V2

const _buyboxType = computed(() => (props.buyboxType === 'list' ? 1 : 0));

const onVisibleCallback = {
	callback: (isVisible: boolean) => {
		if (isVisible) {
			trackEvent({
				action: 'impression',
				value: _buyboxType.value,
			});
		}
	},
	once: true,
};

return { __sfc: true,DEFAULT_PROVIDER_SHORT_NAMES, filterStore, constantStore, userStore, trackEvent, props, providersToDisplay, _buyboxType, onVisibleCallback, ProviderIcon }
}

})